import { Component, forwardRef, inject, Input, model, signal } from '@angular/core';
import { UploadResult } from '../../models/upload-result.model';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AjaxCallService } from '../../services/ajax-call';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-custom-file-upload',
  standalone: false,
  styles: ``,
  templateUrl: './custom-file-upload.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomFileUploadComponent),
    multi: true,
  }],
})
export class CustomFileUploadComponent implements ControlValueAccessor {
  @Input('accepts') accepts: string = '*';

  protected value = signal<UploadResult | null>(null);
  protected disabled = signal(false);

  private onChange: (v: UploadResult | null) => void = () => { };
  private onTouched: () => void = () => { };

  writeValue(v: UploadResult | null): void { this.value.set(v); }        // model → view
  registerOnChange(fn: (v: UploadResult | null) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.disabled.set(isDisabled); }

  private ajax = inject(AjaxCallService);

  fasUpload = faUpload;

  protected onFileSelected(e: any): void {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.onUpload(input.files[0]);
      //this.selectedFile.set(input.files[0]);
    }
  }

  private onUpload(f: File): void {
    if (!f) return;

    // Wrap the file inside standard FormData
    const formData = new FormData();
    formData.append('file', f, f.name);

    this.ajax.MakeCall<UploadResult[]>('/File/Upload', formData).then((result) => {
      this.value.set(result[0]);
      this.onChange(result[0]);
      this.onTouched();
    }, () => { });
  }
}